<template>
    <v-card elevation="0" class="bg-white" variant="outlined" style="border: 1px solid #cfd7df !important;">
        <v-card-title class="text-subtitle-2 bgLight2Theme">Iniciar  chat</v-card-title>
        <v-card-text class="d-flex justify-center align-center pa-2 py-4">
            <v-btn class="bg-indigo-darken-2" elevation="0">Empezar chat</v-btn>
        </v-card-text>
    </v-card>
</template>